import { ShowPerformance } from '../../models/showperformance.model';

export class PerformanceEditDTO {
    performanceId: number;
    performanceAanvang: string;
    performanceNote: string;
    performanceStatus: string;
    toneelmeesterId: number;
    stagemanagerId: number;
    showcallerId: number;
    troubleshooterId: number;
    floortechnicianId: number;
    earlyShiftForStagemanager: boolean;
    earlyShiftForShowcaller: boolean;
    earlyShiftForTroubleshooter: boolean;
    earlyShiftForFloortechnician: boolean;
    earlyShiftForToneelmeester: boolean;
    earlyShiftForExtraCrew: boolean;
    extraCrew: string;

    public convertToDTO(performance: ShowPerformance): PerformanceEditDTO {

        const instance = new PerformanceEditDTO();

        instance.performanceId = performance.id;

        instance.toneelmeesterId = performance?.scheduledToneelmeester?.id || null;
        instance.stagemanagerId = performance?.scheduledStagemanager?.id || null;
        instance.showcallerId = performance?.scheduledShowcaller?.id || null;
        instance.troubleshooterId = performance?.scheduledTroubleshooter?.id || null;
        instance.floortechnicianId = performance?.scheduledFloortechnician?.id || null;
        instance.extraCrew = performance?.extraCrew || null;

        const performanceDatetime = performance.datetime;
        const aanvangstijd = performanceDatetime.split('T')[1];
        instance.performanceAanvang = aanvangstijd.split(':')[0] + ':' + aanvangstijd.split(':')[1];
        instance.performanceNote = performance.notes;
        instance.performanceStatus = performance.status;

        instance.earlyShiftForStagemanager = performance?.earlyShiftForStagemanager;
        instance.earlyShiftForShowcaller = performance?.earlyShiftForShowcaller;
        instance.earlyShiftForFloortechnician = performance?.earlyShiftForFloortechnician;
        instance.earlyShiftForTroubleshooter = performance?.earlyShiftForTroubleshooter;
        instance.earlyShiftForToneelmeester = performance?.earlyShiftForToneelmeester;
        instance.earlyShiftForExtraCrew = performance?.earlyShiftForExtraCrew;

        return instance;
    }

}
